import StatementTop from "../../../components/elements/statements/statementTop";
import StatementBottom from "../../../components/elements/statements/statementBottom";
import CCheckbox from "../../../components/elements/customCheckbox";

import { scrollToElement, formatDate } from "../../../helpers/helpers";
import { mapState } from "ui.vue3.vuex";
import { ClaimStatementStepTwoRadioButtons, StatementComponentNames } from "../../../helpers/data";
import ClaimStatementStepTwo from "./step-2";

const ClaimStatementStepThree = {
    template: /*html*/ `
  <form class="statement-form" action="#">
    <StatementTop
      active-step="3"
      step-amount="3"
    />
    <div class="statement-middle">
      <div class="statement__step statement__step-4">
        <div class="area">
          <div class="area-form">
            <p class="h5">Паспортные данные</p>
            <div class="area-form__fields grid col-xxl-1">
              <div class="area-form__fields-item">
                <div class="dot-leaders">
                  <div class="dot-leaders__item">
                    <div class="dot-leaders__item-title">
                      <p>Фамилия:</p>
                      <div></div>
                    </div>
                    <div class="dot-leaders__item-text">
                      <p>{{statement_data.last_name}}</p>
                    </div>
                  </div>
                  <div class="dot-leaders__item">
                    <div class="dot-leaders__item-title">
                      <p>Имя:</p>
                      <div></div>
                    </div>
                    <div class="dot-leaders__item-text">
                      <p>{{statement_data.first_name}}</p>
                    </div>
                  </div>
                  <div class="dot-leaders__item">
                    <div class="dot-leaders__item-title">
                      <p>Отчество:</p>
                      <div></div>
                    </div>
                    <div class="dot-leaders__item-text">
                      <p>{{statement_data.middle_name}}</p>
                    </div>
                  </div>
                  <div class="dot-leaders__item">
                    <div class="dot-leaders__item-title">
                      <p>Номер телефона:</p>
                      <div></div>
                    </div>
                    <div class="dot-leaders__item-text">
                      <p>{{statement_data.phone}}</p>
                    </div>
                  </div>
                  <div class="dot-leaders__item">
                    <div class="dot-leaders__item-title">
                      <p>Адрес электронной почты:</p>
                      <div></div>
                    </div>
                    <div class="dot-leaders__item-text">
                      <p>{{statement_data.email}}</p>
                    </div>
                  </div>
                  <div class="dot-leaders__item">
                    <div class="dot-leaders__item-title">
                      <p>Серия:</p>
                      <div></div>
                    </div>
                    <div class="dot-leaders__item-text">
                      <p>{{statement_data.passport_series}}</p>
                    </div>
                  </div>
                  <div class="dot-leaders__item">
                    <div class="dot-leaders__item-title">
                      <p>Номер:</p>
                      <div></div>
                    </div>
                    <div class="dot-leaders__item-text">
                      <p>{{statement_data.passport_number}}</p>
                    </div>
                  </div>
                  <div class="dot-leaders__item">
                    <div class="dot-leaders__item-title">
                      <p>Код подразделения:</p>
                      <div></div>
                    </div>
                    <div class="dot-leaders__item-text">
                      <p>{{statement_data.passport_subdivision_code}}</p>
                    </div>
                  </div>
                  <div class="dot-leaders__item">
                    <div class="dot-leaders__item-title">
                      <p>Дата выдачи:</p>
                      <div></div>
                    </div>
                    <div class="dot-leaders__item-text">
                      <p>{{statement_data.passport_date}}</p>
                    </div>
                  </div>
                  <div class="dot-leaders__item">
                    <div class="dot-leaders__item-title">
                      <p>Кем выдан:</p>
                      <div></div>
                    </div>
                    <div class="dot-leaders__item-text">
                      <p>{{statement_data.passport_subdivision_title}}</p>
                    </div>
                  </div>
                  <div class="dot-leaders__item">
                    <div class="dot-leaders__item-title">
                      <p>Адрес:</p>
                      <div></div>
                    </div>
                    <div class="dot-leaders__item-text">
                      <p>{{statement_data.address}}</p>
                    </div>
                  </div>
                  <div class="dot-leaders__item">
                    <div class="dot-leaders__item-title">
                      <p>Разворот паспорта с фотографией:</p>
                      <div></div>
                    </div>
                    <div class="dot-leaders__item-text">{{passportPhotoFilesNames}}</a>
                    </div>
                  </div>
                  <div class="dot-leaders__item">
                    <div class="dot-leaders__item-title">
                      <p>Разворот паспорта с пропиской:</p>
                      <div></div>
                    </div>
                    <div class="dot-leaders__item-text">{{passportAddressFilesNames}}</a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="area">
          <div class="area-form">
            <p class="h5">Информация о платеже</p>
            <div class="area-form__fields grid col-xxl-1">
              <div class="area-form__fields-item">
                <div class="dot-leaders">
                  <div class="dot-leaders__item">
                    <div class="dot-leaders__item-title">
                      <p>Дата:</p>
                      <div></div>
                    </div>
                    <div class="dot-leaders__item-text">
                      <p>{{statement_data.transaction_date}}</p>
                    </div>
                  </div>

                  <div class="dot-leaders__item">
                    <div class="dot-leaders__item-title">
                      <p>Идентификатор (счет, договор и т.д.):</p>
                      <div></div>
                    </div>
                    <div class="dot-leaders__item-text">
                      <p>{{statement_data.transaction_id}}</p>
                    </div>
                  </div>

                  <div class="dot-leaders__item">
                    <div class="dot-leaders__item-title">
                      <p>Провайдер (поставщик услуги):</p>
                      <div></div>
                    </div>
                    <div class="dot-leaders__item-text">
                      <p>{{statement_data.transaction_provider_option.text}}</p>
                    </div>
                  </div>

                  <div class="dot-leaders__item">
                    <div class="dot-leaders__item-title">
                      <p>Сумма, руб.:</p>
                      <div></div>
                    </div>
                    <div class="dot-leaders__item-text">
                      <p>{{statement_data.transaction_summ}}</p>
                    </div>
                  </div>

                  <div class="dot-leaders__item">
                    <div class="dot-leaders__item-title">
                      <p>Платеж:</p>
                      <div></div>
                    </div>
                    <div class="dot-leaders__item-text">
                      <p>{{paymentClaim}}</p>
                    </div>
                  </div>

                  <div class="dot-leaders__item">
                    <div class="dot-leaders__item-title">
                      <p>В связи с чем:</p>
                      <div></div>
                    </div>
                    <div class="dot-leaders__item-text">
                      <p>{{paymentReason}}</p>
                    </div>
                  </div>

                  <div class="dot-leaders__item" v-if="statement_data.payment_reason === 'credit_payment_delayed'">
                    <div class="dot-leaders__item-title">
                      <p>Дата:</p>
                      <div></div>
                    </div>
                    <div class="dot-leaders__item-text">
                      <p>{{statement_data.credit_payment_delayed_date}}</p>
                    </div>
                  </div>

                  <div class="dot-leaders__item" v-if="statement_data.payment_reason === 'credit_payment_delayed'">
                    <div class="dot-leaders__item-title">
                      <p>Сумма ежемесячного платежа по договору:</p>
                      <div></div>
                    </div>
                    <div class="dot-leaders__item-text">
                      <p>{{statement_data.credit_payment_delayed_transaction_summ}}</p>
                    </div>
                  </div>

                  <div class="dot-leaders__item" v-if="statement_data.payment_reason === 'credit_debt_payment_delayed'">
                    <div class="dot-leaders__item-title">
                      <p>Дата:</p>
                      <div></div>
                    </div>
                    <div class="dot-leaders__item-text">
                      <p>{{statement_data.credit_debt_payment_delayed_date}}</p>
                    </div>
                  </div>

                  <div class="dot-leaders__item" v-if="statement_data.payment_reason === 'credit_debt_payment_delayed'">
                    <div class="dot-leaders__item-title">
                      <p>Сумма:</p>
                      <div></div>
                    </div>
                    <div class="dot-leaders__item-text">
                      <p>{{statement_data.credit_debt_payment_delayed_transaction_summ}}</p>
                    </div>
                  </div>

                  <div class="dot-leaders__item" v-if="statement_data.payment_reason === 'payment_reason_other'">
                    <div class="dot-leaders__item-title">
                      <p>Описание:</p>
                      <div></div>
                    </div>
                    <div class="dot-leaders__item-text">
                      <p>{{statement_data.payment_reason_other_text}}</p>
                    </div>
                  </div>
                  
                  <div class="dot-leaders__item">
                    <div class="dot-leaders__item-title">
                      <p>Штрафные санкции<br> в связи с несвоевременным погашением<br> кредитной задолженности Банком/Компанией:</p>
                      <div></div>
                    </div>
                    <div class="dot-leaders__item-text">
                      <p>{{debtFine}}</p>
                    </div>
                  </div>

                  <div class="dot-leaders__item" v-if="statement_data.debt_fine === 'debt_fine_applied'">
                    <div class="dot-leaders__item-title">
                      <p>Сумма ежемесячного платежа по договору, руб.:</p>
                      <div></div>
                    </div>
                    <div class="dot-leaders__item-text">
                      <p>{{statement_data.debt_fine_text}}</p>
                    </div>
                  </div>

                  <div class="dot-leaders__item">
                    <div class="dot-leaders__item-title">
                      <p>Дополнительная информация:</p>
                      <div></div>
                    </div>
                    <div class="dot-leaders__item-text">
                      <p>{{statement_data.additional_info}}</p>
                    </div>
                  </div>

                  <div class="dot-leaders__item" v-if="statement_data.transaction_document_copy_attached">
                    <div class="dot-leaders__item-title">
                      <p>Извещение об оплате<br> или другой документ подтверждающий оплату:</p>
                      <div></div>
                    </div>
                    <div class="dot-leaders__item-text">{{transactionDocumentsNames}}</div>
                  </div>

                  <div class="dot-leaders__item" v-if="!statement_data.transaction_document_copy_attached && statement_data.no_transaction_document_reason">
                    <div class="dot-leaders__item-title">
                      <p>Причина отсутствия копии Извещения об оплате <br> или другого документа, подтверждающего оплату:</p>
                      <div></div>
                    </div>
                    <div class="dot-leaders__item-text">{{statement_data.no_transaction_document_reason}}</div>
                  </div>

                  <div class="dot-leaders__item" v-if="statement_data.debt_fine_document_copy_attached">
                    <div class="dot-leaders__item-title">
                      <p>Копии документов, подтверждающих начисление <br> штрафных санкций и/или иных расходов:</p>
                      <div></div>
                    </div>
                    <div class="dot-leaders__item-text">{{debtFineDocumentNames}}</div>
                  </div>

                  <div class="dot-leaders__item" v-if="!statement_data.debt_fine_document_copy_attached">
                    <div class="dot-leaders__item-title">
                      <p>Причина отсутствия документов, <br> подтверждающих начисление штрафных санкций и/или иных расходов:</p>
                      <div></div>
                    </div>
                    <div class="dot-leaders__item-text">{{statement_data.no_debt_fine_document_reason}}</div>
                  </div>

                  <div class="dot-leaders__item">
                    <div class="dot-leaders__item-title">
                      <p>К заявлению прилагаю копию 2-3 страниц паспорта <br> и адреса места жительства:</p>
                      <div></div>
                    </div>
                    <div class="dot-leaders__item-text">
                      <p>{{statement_data.passport_photo_files.length && statement_data.passport_address_files.length ? 'Да' : 'Нет'}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="statement-final">
          <p class="statement-final__company-name">В АО НКО «ЭЛЕКСНЕТ»</p>
          <div class="h4 statement-final__title">Заявление претензия</div>
          <div class="area">
            <div class="area-form">
              <div class="area-form__fields grid col-xxl-1">
                <div class="area-form__fields-item">
                  <div class="flex">
                    <p>Я, </p><span>{{statement_data.last_name}} {{statement_data.first_name}} {{statement_data.middle_name}}</span>
                  </div>
                  <div class="flex">
                    <p>Дата рождения:</p><span>{{statement_data.birth_date}} </span>
                  </div>
                  <div class="flex">
                    <p>Паспорт:</p>
                    <div class="flex">
                      <p>Серия:</p><span>{{statement_data.passport_series}}</span>
                    </div>
                    <div class="flex">
                      <p>Номер:</p><span>{{statement_data.passport_number}}</span>
                    </div>
                  </div>
                  <div class="flex">
                    <p>Дата выдачи:</p><span>{{statement_data.passport_date}}</span>
                  </div>
                  <div class="flex">
                    <p>Код подразделения:</p><span>{{statement_data.passport_subdivision_code}}</span>
                  </div>
                  <div class="flex">
                    <p>Кем выдан:</p><span>{{statement_data.passport_subdivision_title}}</span>
                  </div>
                  <div class="flex">
                    <p>Адрес:</p><span>{{statement_data.address}}</span>
                  </div>
                </div>
                
                <div class="area-form__fields-item">
                  <div class="flex">
                    <p>Производил(а) оплату</p>
                  </div>
                </div>

                <div class="area-form__fields-item">
                  <div class="flex">
                    <p>Дата:</p><span>{{statement_data.transaction_date}}</span>
                  </div>
                  <div class="flex">
                    <p>Оплаченный идентификатор:</p><span>{{statement_data.transaction_id}}</span>
                  </div>
                  <div class="flex">
                    <p>Провайдер (поставщик услуги):</p><span>{{statement_data.transaction_provider_option.text}}</span>
                  </div>
                  <div class="flex">
                    <p>Сумма:</p><span>{{statement_data.transaction_summ}}</span>
                  </div>
                </div>

                <div class="area-form__fields-item">
                  <div class="flex">
                    <p>Платеж:</p><span>{{paymentClaim}}</span>
                  </div>
                  <div class="flex">
                    <p>В связи с чем:</p><span>{{paymentReason}}</span>
                  </div>

                  <div class="flex" v-if="statement_data.payment_reason === 'credit_payment_delayed'">
                    <p>Дата:</p><span>{{statement_data.credit_payment_delayed_date}}</span>
                  </div>
                  <div class="flex" v-if="statement_data.payment_reason === 'credit_payment_delayed'">
                    <p>Сумма ежемесячного платежа по договору:</p><span>{{statement_data.credit_payment_delayed_transaction_summ}}</span>
                  </div>

                  <div class="flex" v-if="statement_data.payment_reason === 'credit_debt_payment_delayed'">
                    <p>Дата:</p><span>{{statement_data.credit_debt_payment_delayed_date}}</span>
                  </div>
                  <div class="flex" v-if="statement_data.payment_reason === 'credit_debt_payment_delayed'">
                    <p>Сумма:</p><span>{{statement_data.credit_debt_payment_delayed_transaction_summ}}</span>
                  </div>

                  <div class="flex" v-if="statement_data.payment_reason === 'payment_reason_other'">
                    <p>Описание причины:</p><span>{{statement_data.payment_reason_other_text}}</span>
                  </div>
                </div>

                <div class="area-form__fields-item">
                  <div class="flex">
                    <p>Штрафные санкции в связи с несвоевременным погашением кредитной задолженности Банком/Компанией:</span>
                  </div>
                  <div class="flex">
                    <span>{{debtFine}}</span>
                  </div>
                </div>

                <div class="area-form__fields-item" v-if="statement_data.debt_fine === 'debt_fine_applied'">
                  <div class="flex">
                    <p>Сумма санкций:</p><span>{{statement_data.debt_fine_text}} </span><p> руб.</p>
                  </div>
                </div>

                <div class="area-form__fields-item">
                  <div class="flex">
                    <p>Дополнительная информация:</p><span>{{statement_data.additional_info}}</span>
                  </div>
                </div>

                <div class="area-form__fields-item">
                  <div class="flex">
                    <p>К заявлению прилагаю копию Извещения:</p><span>{{statement_data.transaction_document_copy_attached ? 'Да' : 'Нет'}}</span>
                  </div>
                </div>

                <div class="area-form__fields-item" v-if="!statement_data.transaction_document_copy_attached">
                  <div class="flex">
                    <p>Причина отсутствия копии Извещения об оплате или другого документа, подтверждающего оплату:</p><span>{{statement_data.no_transaction_document_reason}}</span>
                  </div>
                </div>

                <div class="area-form__fields-item">
                  <div class="flex">
                    <p>К заявлению прилагаю копию документов, подтверждающих начисление  штрафных санкций и/или иных расходов::</p><span>{{statement_data.debt_fine_document_copy_attached ? 'Да' : 'Нет'}}</span>
                  </div>
                </div>

                <div class="area-form__fields-item" v-if="!statement_data.debt_fine_document_copy_attached">
                  <div class="flex">
                    <p>Причина отсутствия документов, подтверждающих начисление штрафных санкций и/или иных расходов:</p><span>{{statement_data.no_transaction_document_reason}}</span>
                  </div>
                </div>

                <div class="area-form__fields-item">
                  <div class="flex">
                    <p>К заявлению прилагаю копию 2-3 страниц паспорта и адреса места жительства:</p><span>{{statement_data.passport_photo_files.length && statement_data.passport_address_files.length ? 'Да' : 'Нет'}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="statement-final__bottom-text">
            <p>В соответствии с Федеральным законом от 27.07.2006 № 152-ФЗ «О персональных данных» даю согласие АО НКО «ЭЛЕКСНЕТ» на обработку моих персональных данных свободно, своей волей и в своем интересе, совершаемых с использованием средств автоматизации или без использования таких средств, а также на передачу такой информации третьим лицам в целях выполнения договорных отношений, включая выполнение действия по сбору, систематизации, накоплению, хранению, уточнению (обновлению, изменению), распространению (в том числе передаче) и уничтожению моих персональных данных. Я утверждаю, что ознакомлен с моими правами и обязанностями в этой области. Согласие вступает в силу со дня его подписания и действует до его отзыва. Согласие может быть отозвано мною в любое время на основании моего письменного заявления.</p>
          </div>
        </div>

        <div class="area">
          <CCheckbox
            :title="pd_agreement.title"
            :checkbox-id="pd_agreement.id"
            :check-var="data.pd_agreement"
            @on_change="onPdAgreementChange"
          />
        </div>

      </div>
    </div>
    <StatementBottom 
      :next-btn="next_btn"
      :back-btn="back_btn"
      @back_clicked="onBackClicked"
      @next_clicked="onNextClicked"
    />
  </form>
  `,

    name: StatementComponentNames.claim.claim_three,

    props: {
        statementAnchor: {
            type: String,
            default: "",
        },

        goToComponent: {
          type: Function
        }
    },

    computed: {
        ...mapState({
            statement_data: (state) => state.claim.data,
            statement_data_sent: (state) => state.claim.data_send,
            statement_data_send_error: (state) => state.errorController.error,
        }),

        paymentClaim() {
            return ClaimStatementStepTwoRadioButtons[this.statement_data.payment_claim].text;
        },

        paymentReason() {
            return ClaimStatementStepTwoRadioButtons[this.statement_data.payment_reason].text;
        },

        debtFine() {
            return ClaimStatementStepTwoRadioButtons[this.statement_data.debt_fine].text;
        },

        debtFineDocumentNames() {
          let files_names_string = ""

          if(this.statement_data.debt_fine_document_files) {
            this.statement_data.debt_fine_document_files.forEach((file) => {
              files_names_string += `${file.name} ,`;
            });
          }
          
          return files_names_string.substring(0, files_names_string.length - 2);
        },

        transactionDocumentsNames() {
          let files_names_string = ""

          if(this.statement_data.transaction_document_files) {
            this.statement_data.transaction_document_files.forEach((file) => {
              files_names_string += `${file.name} ,`;
            });
          }
          
          return files_names_string.substring(0, files_names_string.length - 2);
        },

        passportAddressFilesNames() {
          let files_names_string = "";
          if(this.statement_data.passport_address_files.length) {
            this.statement_data.passport_address_files.forEach((file) => {
              files_names_string += `${file.name} ,`;
            });
          }
          
          return files_names_string.substring(0, files_names_string.length - 2);
        },

        passportPhotoFilesNames() {
          let files_names_string = "";

          if(this.statement_data.passport_photo_files.length) {
            this.statement_data.passport_photo_files.forEach((file) => {
              files_names_string += `${file.name} ,`;
            });
          }
          
          return files_names_string.substring(0, files_names_string.length - 2);
        }
    },

    data() {
        return {
            next_btn: {
                show: true,
                text: "Отправить",
                class: "",
                disabled: true,
            },

            back_btn: {
                show: true,
                text: "Назад",
                class: "",
            },

            pd_agreement: {
                title: "Я даю свое согласие",
                id: "pd_agreement",
            },

            data: {
                pd_agreement: false,
            },

            tabs: {
                card: "card",
                requisites: "requisites",
                mobile: "mobile",
                other: "other",
            },

            modal: {
                text: `<p>Срок обработки до 10-ти рабочих дней. На указанный Вами электронный адрес будет направлен регистрационный номер обращения.</p>
              <p>При необходимости получения дополнительной информации наши специалисты свяжутся с Вами по указанному Вами контактному телефону или адресу электронной почты.</p>`,
                title: `<p>Ваше заявление <br> принято в работу!</p>`,
            },
        };
    },

    created() {
        this.getStoreData();
        this.onPdAgreementChange(this.data.pd_agreement);
    },

    methods: {
        onBackClicked() {
            this.setStatementData();
            this.scrollToTop();
            this.goToComponent({ component: ClaimStatementStepTwo });
        },

        async onNextClicked() {
            if (this.statement_data_send_error || this.statement_data_sent) {
                return;
            }

            await this.$store.dispatch("claim/CLAIM_SEND_DATA_ACT", this.statement_data);

            if (this.statement_data_sent) {
                this.$store.dispatch("modal/open", {
                    title: this.modal.title,
                    text: this.modal.text,
                    type: "statement-success",
                    callback: () => {
                        window.location.replace(window.location.origin + "/help/application/");
                    },
                });
            }
        },

        onPdAgreementChange(val, id) {
            this.data.pd_agreement = val;

            if (this.data.pd_agreement) {
                this.next_btn.disabled = false;
            }

            if (!this.data.pd_agreement) {
                this.next_btn.disabled = true;
            }
        },

        getStoreData() {
            this.data.pd_agreement = this.statement_data.pd_agreement;
        },

        setStatementData() {
            this.$store.commit("claim/setThirdStepData", { data: this.data });
        },

        scrollToTop() {
            const el = document.querySelector(`#${this.statementAnchor}`);

            if (el) {
                scrollToElement({ el: el, time: 200, animation: "swing" });
            }
        },

        formatDate(date) {
            return formatDate(date);
        },
    },

    components: {
        StatementTop,
        StatementBottom,
        CCheckbox,
        ClaimStatementStepTwo,
    },
};

export default ClaimStatementStepThree;
